import { axiosInstance } from "../../utils/axios";

export class TableCell {
  row: number;
  column: number;
  value: any;
}

/**
 * DB api
 */
export interface UserDB {
  uid: string;
  id: string;
  fake: boolean;
  desc: string;
  partiallyBlocked: boolean;
  blocked: boolean;
}

export function fetchGroupUserDB(): Promise<UserDB[]> {
  return axiosInstance
    .get("/user/dblist")
    .then((resp) => resp.data)

    .catch((reason) => console.log(`Error on fetching remote data: ${reason}`));
}

/**
 * Form api
 */
export interface Form {
  oid: string;
  code: string;
  desc: string;
  type: "node" | "form";
}

export function fetchFormNode(dbId: string, oid?: string): Promise<Form[]> {
  return axiosInstance
    .get(`/form/tree/${dbId}` + (oid !== undefined ? `/${oid}` : ""), { params: { notShowLoading: true } })
    .then((resp) => resp.data)

    .catch((reason) => console.log(`Error on fetching remote data: ${reason}`));
}
export function fetchFormSearchResults(dbId: string, searchQuery: string): Promise<Form[]> {
  return axiosInstance
    .get(`/form/tree/${dbId}` + (searchQuery !== undefined ? `/search/${searchQuery}` : ""), { params: { notShowLoading: true } })
    .then((resp) => resp.data)

    .catch((reason) => console.log(`Error on fetching remote data: ${reason}`));
}

/**
 * Sheet api
 */
export interface Sheet {
  uid: string;
  code: string;
  desc: string;
  areas: string[];
  charts: string[];
}

export function fetchSheet(dbId: string, code: string, type: string): Promise<Sheet[]> {
  const path = type == "CHART" ? "sheetandcharts" : "sheetandareas";
  return axiosInstance
    .get(`/form/${path}/${dbId}/${code}`)
    .then((resp) => resp.data)

    .catch((reason) => console.log(`Error on fetching remote data: ${reason}`));
}
